import React from 'react';
import './sante.css';
import Footer from '../Footer';
import doctor from '../../img/doctor.png';
import doctor1 from '../../img/doctor1.png';
import { BsJournalPlus } from "react-icons/bs";
import { FaTooth } from "react-icons/fa";
import { FaHeartbeat } from "react-icons/fa";
import { MdOutlineEmergency } from "react-icons/md";
import { FaTablets } from "react-icons/fa";
import { FaDna } from "react-icons/fa";
import { FaAmbulance } from "react-icons/fa";
import { MdFactCheck } from "react-icons/md";
import { FaUserMd } from "react-icons/fa";

const Sante = ()=>{

    return(
        <div>
            <header className='text-start p-5 mb-5 bg-primary text-light'>
                <h1>Sante</h1>
                <h3>Accueil / Sante</h3>
            </header>

            <div className='container text-center'>

                <div className="row mb-3">
                    <div className="col-sm-6 col-md-3 ">
                        <div className="card  pt-3">
                            <div className="icone">
                                <FaUserMd />
                            </div>

                            <div class="card-body">
                                <h5 className="card-title title-card ">Mèdecin Expert</h5>
                                <p className="card-text">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                                do eiusmod
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-6 col-md-3">
                        <div className="card pt-3">
                            <div className="icone">
                                <MdFactCheck />
                            </div>

                            <div class="card-body">
                                <h5 className="card-title title-card ">Diagnostic</h5>
                                <p className="card-text">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                                do eiusmod
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-6 col-md-3">
                        <div className="card pt-3">
                            <div className="icone">
                                <BsJournalPlus />
                            </div>

                            <div class="card-body">
                                <h5 className="card-title title-card ">Pathologie</h5>
                                <p className="card-text">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                                do eiusmod
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-6 col-md-3">
                        <div className="card pt-3">
                            <div className="icone">
                            <FaTooth />
                            </div>

                            <div class="card-body">
                                <h5 className="card-title title-card ">Soins Dentaires</h5>
                                <p className="card-text">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                                do eiusmod
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row ">
                    <div className="col-sm-6 col-md-3 ">
                        <div className="card  pt-3">
                            <div className="icone">
                                <FaHeartbeat />
                            </div>

                            <div class="card-body">
                                <h5 className="card-title title-card ">Cardiologie</h5>
                                <p className="card-text">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                                do eiusmod
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-6 col-md-3">
                        <div className="card pt-3">
                            <div className="icone">
                                <FaTablets />
                            </div>

                            <div class="card-body">
                                <h5 className="card-title title-card ">Mèdecine</h5>
                                <p className="card-text">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                                do eiusmod
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-6 col-md-3">
                        <div className="card pt-3">
                            <div className="icone">
                                <FaDna />
                            </div>

                            <div class="card-body">
                                <h5 className="card-title title-card ">Neurologie</h5>
                                <p className="card-text">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                                do eiusmod
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-6 col-md-3">
                        <div className="card pt-3">
                            <div className="icone">
                                <FaAmbulance />
                            </div>

                            <div class="card-body">
                                <h5 className="card-title title-card ">Ambulance</h5>
                                <p className="card-text">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                                do eiusmod
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div className="container mt-5 text-center">
                <h2 className='fs-1 text-uppercase '>Notre Expertise</h2>
                {/* experitse row */}
                <div className="row">
                    <div className="col-sm-6 col-md-3 mt-5">
                        <div className="card text-white bg-primary pt-3">
                            <div className="icone text-white ">
                                <FaUserMd />
                            </div>
                            <div class="card-body">
                                <h5 className="card-title title-card ">Docteur Certifié</h5>
                                <p className="card-text">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                                do eiusmod
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-6 col-md-3 mt-5 ">
                        <div className="card pt-3 bg-primary text-white">
                            <div className="icone text-white">
                                <MdOutlineEmergency  />
                            </div>
                            <div class="card-body">
                                <h5 className="card-title title-card ">Urgence</h5>
                                <p className="card-text">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                                do eiusmod
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className=" col-md-5 d-none d-md-block">
                        <img src={doctor} alt="doctor image" className='w-100 h-100'/>
                    </div>
                </div>
                {/* experitse row */}
                <div className="row pt-5">
                    <div className=" col-md-5 d-none d-md-block">
                        <img src={doctor1} alt="doctor image" className='w-100 h-100'/>
                    </div>
                    <div className="col-sm-6 col-md-3 mt-5">
                        <div className="card text-white bg-primary pt-3">
                            <div className="icone text-white ">
                                <FaUserMd />
                            </div>
                            <div class="card-body">
                                <h5 className="card-title title-card ">Docteur Certifié</h5>
                                <p className="card-text">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                                do eiusmod
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6 col-md-3 mt-5 ">
                        <div className="card pt-3 bg-primary text-white">
                            <div className="icone text-white">
                                <MdOutlineEmergency  />
                            </div>
                            <div class="card-body">
                                <h5 className="card-title title-card ">Urgence</h5>
                                <p className="card-text">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                                do eiusmod
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            
            <Footer />
        </div>
    )
}

export default Sante;